export default import.meta.ROLLDOWN_FILE_URL_EGre3KNbaaAfihEAhTGFNQ